import { useEffect, useState } from "react";

const KEY = "srd_cookies_v1";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setShow(true);
  }, []);

  const accept = (mode) => {
    localStorage.setItem(KEY, JSON.stringify({ mode, at: new Date().toISOString() }));
    setShow(false);
  };

  if (!show) return null;
  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-black/10 bg-white"
    >
      <div className="max-w-screen-xl mx-auto p-6 flex flex-col md:flex-row items-start md:items-center gap-4">
        <p className="text-sm text-foreground/80 flex-1">
          Мы используем cookies, чтобы сайт работал корректно. Подробнее — в политике обработки данных.
        </p>
        <div className="flex gap-3">
          <button data-testid="cookie-essential-btn" className="btn-secondary" onClick={() => accept("essential")}>
            Только необходимые
          </button>
          <button data-testid="cookie-accept-btn" className="btn-primary" onClick={() => accept("all")}>
            Принять
          </button>
        </div>
      </div>
    </div>
  );
}
